import { Component } from '@angular/core';
import { NavController,AlertController,App} from 'ionic-angular';
import { VersionUpdatePage } from "../version/updateversion";
import { ModifyPasswordPage } from "../password/modifypwd";
import { StorageService } from '../../../providers/service/storageservice';
import { WebService } from '../../../providers/service/webservice';
import { PERSONINFO} from '../../../providers/config/serviceurl';
import { LoginPage } from '../../login/login/login';
import { BindPhonePage } from "../bind/bindphone";
import { SkinPage } from "../skin/skin";
import { AppState } from '../../../app/app.global';
import { PersonalInfo } from '../../application/teaching/personalinfo/personalinfo';
import { AccountPage } from '../account/account';
import { BookborrowPage } from '../bookborrow/bookborrow';
import { OnecardPage } from '../onecard/onecard';
import { SettingPage } from '../setting/setting';
import {Utils} from '../../../providers/service/utils';

@Component({
  selector: 'about-home-page',
  templateUrl: 'abouthome.html'
})
export class AboutHomePage {
	user:any =null;
	userInfo:any = {};
	resourceUrl:any;//资源url；
  //themes:string ="";
  //bg:string ="";
	constructor (public navCtrl: NavController,public appCtrl: App,private alertCtrl: AlertController,public global: AppState,private webService:WebService) {
    if(global.colorTheme == null){//初始的时候如果为空设置颜色
			StorageService.setObj('colorTheme',"color40A0F6");
		}
		this.resourceUrl = StorageService.getObj('resourceUrl');
    //this.themes =  global.colorTheme.replace("color","#");
    //this.bg =  global.colorTheme.replace("color","");
		this.user = StorageService.getObj('currentUser');
    if(!Utils.isLogined()){
			this.appCtrl.getRootNav().push(LoginPage);
		}
	}
  ionViewDidEnter(){
   //if(null!=StorageService.getObj('colorTheme'))
     //this.themes =  StorageService.getObj('colorTheme').replace("color","#");
    //this.bg =  StorageService.getObj('colorTheme').replace("color","");

  }
	openSkinPage(){
	//	this.navCtrl.push(SkinPage,{});
		this.appCtrl.getRootNav().push(SkinPage,{});
	}
	
	//账户管理
	openAccountPage(){
		this.appCtrl.getRootNav().push(AccountPage,{});
	}

//校园一卡通
	schoolOneCard(){
  	this.appCtrl.getRootNav().push(OnecardPage,{});
	}
	//图书借阅
	bookBorrow(){
  	this.appCtrl.getRootNav().push(BookborrowPage,{});
	}
//设置
	openSetting(){
		// this.navCtrl.push(SettingPage,{});
		this.appCtrl.getRootNav().push(SettingPage,{});
	}

//登录
  loginOut(){
		StorageService.remove('currentUser');
		this.appCtrl.getRootNav().push(LoginPage);
	}
}



// WEBPACK FOOTER //
// ./src/pages/about/home/abouthome.ts